module.exports = __webpack_public_path__ + "img/condom.50cfb3d7.jpg";